import { fetchAuthSession } from "aws-amplify/auth";
import { jwtDecode } from "jwt-decode";

// ---

export const GROUP_TILLEY_LENDERS = "Tilley-Lenders";
export const GROUP_TILLEY_BROKERS = "Tilley-Brokers";

export function AmplifySessionManager() {
  var _isAuthenticated = false;

  const getBearerToken = async () => {
    const { tokens } = await fetchAuthSession();
    const idToken = tokens?.idToken;

    return idToken.toString();
  };

  const getUserGroups = async () => {
    try {
      const token = await getBearerToken();
      const decodedToken = jwtDecode(token);
      const groups = decodedToken["cognito:groups"] || [];
      return groups;
    } catch (error) {
      console.error("Error getting user groups:", error);
    }
  };

  const setBearerToken = async (value) => {
    // NOOP
  };

  // ---

  const getRefreshToken = async () => {
    // https://github.com/aws-amplify/amplify-js/issues/2560
    try {
      const session = await fetchAuthSession({ forceRefresh: true });

      const accessToken = session.tokens?.accessToken?.toString();

      if (!accessToken) {
        throw new Error("Failed to retrieve access token");
      }

      return accessToken;
    } catch (error) {
      console.error("Error refreshing access token:", error);
      return null;
    }
  };

  const setRefreshToken = async (value) => {
    // noop
  };

  // ---

  const setIsAuthenticated = (__isAuthenticated) => {
    //console.log("auth SessionManager setIsAuthenticated", __isAuthenticated);
    _isAuthenticated = __isAuthenticated;
  };

  const getIsAuthenticated = () => {
    //console.log("auth SessionManager getIsAuthenticated", _isAuthenticated);
    return _isAuthenticated;
  };

  return {
    setBearerToken,
    getBearerToken,
    setRefreshToken,
    getRefreshToken,

    getUserGroups,

    setIsAuthenticated,
    getIsAuthenticated,
  };
}
